import {all, fork} from 'redux-saga/effects';
import manager from './manager.js';
import companies from './companies.js';
import task from './task.js';
import agent from './agent.js';


export default function* watchers() {
    yield all([
        manager,companies,task,agent
    ].map(fork));
}
